import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Listbox, Transition } from '@headlessui/react';
import Loader from '../components/Loader';
import { fetchTicketById } from '../api/zoho';
import { fetchCity, fetchSuburb } from '../api/dropdown';
import { updateTicketById } from '../api/zoho';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import UpdateInquiryFormScreen from './UpdateInquiryFormScreen';

const people = ['منشأ', 'تحت العمل', 'منتهي', 'ملغي'];
const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
let citys = [
  { id: 1, name: 'طرابلس' },
  { id: 2, name: 'مصراتة' },
  { id: 3, name: 'بنغازي' },
];
let suburbs = [
  { id: 1, name: '11يونيو' },
  { id: 2, name: 'الحي الاسلامي' },
  { id: 3, name: 'السبعة' },
];

const TicketMidleWare = () => {
  let { phoneNumber, id } = useParams();
  let navigate = useNavigate();
  const [loadding, setLoadding] = useState(false);
  const [error, setError] = useState('');
  const [ticket, setTicket] = useState();

  useEffect(() => {
    setLoadding(true);
    setError('');
    try {
      fetchTicketById(id)
        .then((data) => {
          if (data.success === false) {
            if (data.error.response.status == 404) {
              // toast.error('لا يوجد بيانات لعرضها');
              // navigate(`/IncomingCallScreen/${phoneNumber}`);
            }
          }
          if (data.success === true) {
            if (data?.data) {
              // toast.success('تم تحميل البيانات بنجاح');
              setTicket(data.data);
              console.log(data);
              if (data?.data?.cf.cf_nw_almkalmt === 'استفسار') {
                navigate(
                  `/UpdateInquiryFormScreen/${phoneNumber}/${data?.data?.id}`,
                  {
                    state: {
                      account: data?.data,
                    },
                  }
                );
              } else if (data?.data?.cf.cf_nw_almkalmt === 'شكوى') {
                navigate(
                  `/UpdateComplaintFormScreen/${phoneNumber}/${data?.data?.id}`,
                  {
                    state: {
                      account: data?.data,
                    },
                  }
                );
              } else if (data?.data?.cf.cf_nw_almkalmt === 'طلب خدمة') {
                navigate(
                  `/UpdateServiceRequestFormScreen/${phoneNumber}/${data?.data?.id}`,
                  {
                    state: {
                      account: data?.data,
                    },
                  }
                );
              } else {
                navigate(`/CalLlogsScreen/${phoneNumber}`);
              }
            } else {
              // toast.error('لا يوجد بيانات لعرضها');
            }
          } else {
            // toast.error('لا يوجد بيانات لعرضها');
          }
        })
        .catch((err) => {
          // setError(err.message);

          // toast.error('حدث خطأ ما');
          console.log(err, 'err');
        })
        .finally(() => {
          setLoadding(false);
        });
    } catch (error) {
      setError(error.message);
    }
  }, []);

  return (
    <div className='h-full justify-center align-middle bg-background-100 min-h-screen'>
      <div className='flex justify-center pt-44'>
        <Loader />
      </div>
    </div>
  );
};

export default TicketMidleWare;
